/**
 * Os desenhos do feedback da equipe — usados pelo botão flutuante e pela aba
 * "Equipe" da tela de feedbacks. A cor de cada tipo vem das classes
 * `.fb-problema`, `.fb-ideia` e `.fb-elogio` (botaoDeFeedback.css), que
 * publicam `--fb-cor`, `--fb-soft` e `--fb-on-soft` com os tokens do tema.
 */

import type { ReactNode } from "react"
import type { CodigoDoTipo } from "@/api/feedbackDoSistema"
import "./botaoDeFeedback.css"

export function Icone({ d, tamanho = 16, largura = 1.8 }: { d: string; tamanho?: number; largura?: number }) {
  return (
    <svg
      width={tamanho} height={tamanho} viewBox="0 0 24 24" aria-hidden="true"
      style={{ fill: "none", stroke: "currentColor", strokeWidth: largura, strokeLinecap: "round", strokeLinejoin: "round", flex: "0 0 auto" }}
    >
      <path d={d} />
    </svg>
  )
}

const DESENHO: Record<CodigoDoTipo, string> = {
  problema:
    "M9 7.5a3 3 0 0 1 6 0 M8 9.5h8v4a4 4 0 0 1-8 0v-4Z M12 12v5.5 M4 12.5h4 M16 12.5h4 M5 7.5l3 2 M19 7.5l-3 2 M5.5 18.5l2.8-2 M18.5 18.5l-2.8-2",
  ideia:
    "M9.5 18h5 M10.5 21h3 M12 3a6 6 0 0 0-3.7 10.7c.7.6 1.2 1.4 1.2 2.3h5c0-.9.5-1.7 1.2-2.3A6 6 0 0 0 12 3Z",
  elogio:
    "M12 20s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7a4.3 4.3 0 0 1 7.5 2.8C19.5 15.4 12 20 12 20Z",
}

export function IconeDoTipo({ tipo, tamanho = 19 }: { tipo: CodigoDoTipo; tamanho?: number }): ReactNode {
  return <Icone d={DESENHO[tipo] ?? DESENHO.ideia} tamanho={tamanho} />
}

export const D = {
  fechar: "M6 6l12 12M18 6 6 18",
  check: "m6.5 12.5 3.5 3.5 7.5-8",
  alerta: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z M12 8v5 M12 16.5v.01",
  local: "M12 21s-6-5.3-6-11a6 6 0 1 1 12 0c0 5.7-6 11-6 11Z M12 8.2a1.8 1.8 0 1 0 0 3.6 1.8 1.8 0 0 0 0-3.6Z",
  imagem: "M5 4h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z M9 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z m12 7.5-4.5-4.5L7 21",
  tela: "M4 5h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z M9 21h6 M12 17v4",
  enviar: "M4.5 11.6 19.6 4.4c.6-.3 1.2.3.9.9l-7.2 15.1c-.3.6-1.1.5-1.3-.1l-1.7-5.3-5.3-1.7c-.6-.2-.7-1-.1-1.3Z M10.3 14.9 14 11.2",
  balao: "M20 11.5a7.5 7.5 0 0 1-10.9 6.7L4.5 19.5l1.2-4.1A7.5 7.5 0 1 1 20 11.5Z M9 10h6 M9 13h3.5",
  seta: "M9 6l6 6-6 6",
  voltar: "M15 6l-6 6 6 6",
  baixar: "M12 4v11 M7.5 10.5 12 15l4.5-4.5 M5 19h14",
  reabrir: "M4 12a8 8 0 1 0 2.4-5.7 M4 4v4.5h4.5",
} as const
